"use client";
import SectionTitle from "@components/elements/SectionTitle";
import CategorySlider1 from "@components/slider/CategorySlider1";
import Link from "next/link";

const Category = ({category, pages}) => {
  const currentPageAide = pages.find(item => item.id === 64);
  const currentPage = pages.find(item => item.id === 67);
  const link = currentPageAide?.seo_permalink + "/" + currentPage?.seo_permalink;
  return (
    <>
      <div className="section-padding pb-0">
        <div className="container">
          <SectionTitle
            style={1}
            title={currentPage?.seo_title}
            subTitle={<Link href={link}>{currentPage?.title}</Link>}
          />
          <div className="category-slider1">
            <CategorySlider1 category={category} currentPageAide={currentPageAide} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Category;
